import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
  faUtensils,
  faBus,
  faBuilding
} from "@fortawesome/free-solid-svg-icons";

import ReusableGoogleMapWithPanel from "../ReusableGoogleMapWithPanel";

/* ===========================
   CATEGORY CONFIG
=========================== */

const CATEGORIES = [
  {
    key: "food",
    label: "Food & Drink",
    icon: faUtensils,
    marker: "/markers/mappin_orange.png",
    api: "/resolutionsoftwareplatform/api/local-info/places?type=RESTAURANTS&lat=51.5074&lng=-0.1278",
    sub: ["Cafe", "Restaurant", "Bar", "Fast Food"]
  },
  {
    key: "transport",
    label: "Transport",
    icon: faBus,
    marker: "/markers/bluepin.png",
    api: "/resolutionsoftwareplatform/api/local-info/places?type=EV_CHARGING&lat=51.5074&lng=-0.1278",
    sub: ["Bus Stop", "Train", "Underground", "EV Charging"]
  },
  {
    key: "amenities",
    label: "Amenities",
    icon: faBuilding,
    marker: "/markers/yellowpin.png",
    api: "",
    sub: ["Pharmacy", "Hospital", "ATM", "Gym"]
  }
];

/* ===========================
   COMPONENT
=========================== */

export default function OmniLocalInfoDrawer() {

  const [openCategory, setOpenCategory] = useState(null);
  const [activeSub, setActiveSub] = useState(null);
  const [apiUrl, setApiUrl] = useState("");
  const [markerUrl, setMarkerUrl] = useState("");

  return (
    <div style={layout}>

      {/* LEFT PANEL */}
      <div style={leftPanel}>

        {CATEGORIES.map(cat => {
          const open = openCategory === cat.key;

          return (
            <div key={cat.key} style={{ marginBottom: 14 }}>

              {/* CATEGORY HEADER */}
              <div
                onClick={() => {
                  setOpenCategory(open ? null : cat.key);
                  setActiveSub(null);
                }}
                style={{
                  ...categoryBox,
                  ...(open && categoryBoxOpen)
                }}
              >
                <div style={categoryLabel}>
                  <FontAwesomeIcon icon={cat.icon} />
                  {cat.label}
                </div>

                <FontAwesomeIcon
                  icon={open ? faChevronDown : faChevronRight}
                />
              </div>

              {/* SUB CATEGORIES */}
              <div
                style={{
                  ...subPanel,
                  maxHeight: open ? 240 : 0
                }}
              >
                {cat.sub.map(sub => (
                  <div
                    key={sub}
                    onClick={() => {
                      setActiveSub(sub);
                      setApiUrl(cat.api);
                      setMarkerUrl(cat.marker);
                    }}
                    style={{
                      ...subItem,
                      ...(activeSub === sub && subItemActive)
                    }}
                  >
                    <FontAwesomeIcon icon={faChevronRight} />
                    {sub}
                  </div>
                ))}
              </div>

            </div>
          );
        })}
      </div>

      {/* MAP */}
      <div style={mapWrap}>
        <ReusableGoogleMapWithPanel
          apiUrl={apiUrl}
          markerIcon={markerUrl}
          center={{ lat: 51.5074, lng: -0.1278 }}
          activeSub={activeSub}
        />
      </div>

    </div>
  );
}

/* ===========================
   STYLES
=========================== */

const layout = {
  display: "flex",
  height: "100%"
};

const leftPanel = {
  width: 230,
  padding: 16,
  background:
    "linear-gradient(180deg, #151a22 0%, #0c1016 100%)",
  borderRight: "1px solid rgba(255,255,255,0.06)",
  borderTopLeftRadius:'13px',
  		borderBottomLeftRadius:'13px'
};

const categoryBox = {
  padding: "14px 16px",
  borderRadius: 16,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 800,
  color: "#dfe6f0",
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))",
  border: "1px solid rgba(255,255,255,0.08)",
  transition: "all 0.25s ease"
};

const categoryBoxOpen = {
  background:
    "linear-gradient(180deg, #2b6fe3, #1e4fbf)",
  boxShadow: "0 8px 20px rgba(0,0,0,0.45)"
};

const categoryLabel = {
  display: "flex",
  gap: 10,
  alignItems: "center"
};

const subPanel = {
  overflow: "hidden",
  transition: "max-height 0.45s ease",
  marginTop: 6
};

const subItem = {
  padding: "10px 18px",
  display: "flex",
  gap: 10,
  alignItems: "center",
  cursor: "pointer",
  fontSize: 13,
  color: "#c9d3e0",
  borderRadius: 12,
  marginTop: 6,
  background: "rgba(255,255,255,0.02)",
  transition: "all 0.2s ease"
};

const subItemActive = {
  background:
    "linear-gradient(180deg, rgba(77,163,255,0.35), rgba(43,111,227,0.35))",
  color: "#ffffff",
  fontWeight: 800
};

const mapWrap = {
  flex: 1,
  position: "relative",
  overflow: "hidden",
  borderRadius: 18,
  margin: 16,
  boxShadow: "0 12px 40px rgba(0,0,0,0.6)"
};
